export const CONTACT_EMAIL = '0610studio@barabom.me';

export const CONTACT_EMAIL_MAILTO = `mailto:${CONTACT_EMAIL}`;

export const CUSTOMER_CENTER_PHONE = '+82 10-2286-9185';

export const CUSTOMER_CENTER_PHONE_TEL = 'tel:+821022869185';

export const CONTACT_KAKAO_ID = 'right-hot';

export const CONTACT_KAKAO_URL = 'https://open.kakao.com/me/barabom';

export const BUSINESS_REGISTRATION_NUMBER = '460-08-02680';

export const MAIL_ORDER_BUSINESS_REPORT_NUMBER = '제 2026-서울도봉-0268 호';

export const BUSINESS_ADDRESS = {
  en: '50 Haedeung-ro, Dobong-gu, Seoul, Republic of Korea',
  ja: '大韓民国 ソウル特別市 道峰区 Haedeung-ro 50',
  ko: '서울특별시 도봉구 해등로 50',
};

export const BUSINESS_NAME = {
  en: 'Barabom',
  ja: 'ほほみる',
  ko: '바라봄',
};

export const BUSINESS_REPRESENTATIVE = {
  en: 'KimJeonghun',
  ja: 'KimJeonghun',
  ko: '김정훈',
};

export const BUSINESS_CATEGORY = {
  en: 'Information and communication / Application software publishing',
  ja: '情報通信業 / アプリケーションソフトウェア開発・供給業',
  ko: '정보통신업 / 응용 소프트웨어 개발 및 공급업',
};
